<template>
  <div
    class="add-place"
    :class="{ 'add-place--no-pointer': isPlacePickerActive }"
  >
    <transition name="fade"><router-view/></transition>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import store from '@/store'
import {
  SET_HERO_ANIMATION,
  SET_VIDEO_LOADED,
  SHOW_PLACE_PICKER,
  HIDE_PLACE_PICKER
} from '@/store/mutation-types'

export default {
  computed: {
    ...mapState({
      isPlacePickerActive: state => state.picker.isActive
    })
  },
  beforeRouteEnter (to, from, next) {
    store.commit(SHOW_PLACE_PICKER)
    next()
  },
  beforeDestroy () {
    this.hidePlacePicker()
  },
  created () {
    this.setHeroAnimation()
    this.setVideoLoaded()
  },
  methods: {
    ...mapMutations({
      setHeroAnimation: SET_HERO_ANIMATION,
      setVideoLoaded: SET_VIDEO_LOADED,
      hidePlacePicker: HIDE_PLACE_PICKER
    })
  }
}
</script>

<style lang="scss" scoped>
  .add-place {
    @include full-size(fixed);

    z-index: z(submit-map);
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    &--no-pointer {
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/AddPlace.vue